// Auto-generated enum from table FileTypes

export const photoName = {
    contactPhoto: 'contactPhoto',
    domainPhoto: 'domainPhoto',
    domainUserPhoto: 'domainUserPhoto',
    noticePhoto: 'noticePhoto',
    projectMemberPhoto: 'projectMemberPhoto',
    projectPhoto: 'projectPhoto',
    taskPhoto: 'taskPhoto',
    userPhoto: 'userPhoto',
}

export type TPhotoName = (typeof photoName)[keyof typeof photoName];

